import { render } from "./PixKeyClaimRequestApproval.vue?vue&type=template&id=244743a6"
import script from "./PixKeyClaimRequestApproval.vue?vue&type=script&lang=js"
export * from "./PixKeyClaimRequestApproval.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__